import Wix from './wix-sdk-polyfill';
import { setViewMode } from '../store/basic-params/basic-params-actions';

export default function listenToEditModeChange(store) {
  store.dispatch(setViewMode(Wix.Utils.getViewMode().toLowerCase()));

  Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, ({ editMode }) => {
    store.dispatch(setViewMode(editMode.toLowerCase()));
  });
}
